import { LayoutTemplate, Pencil, Play } from 'lucide-react'

const STEPS = [
	{
		number: 1,
		icon: LayoutTemplate,
		title: 'Define your terminology',
		description: 'Name your formations, routes, and concepts once. PlaySmith learns the language your staff already speaks.',
	},
	{
		number: 2,
		icon: Pencil,
		title: 'Type your play',
		description: 'Describe your play in plain English. PlaySmith recognizes your terminology and builds it on the canvas instantly.',
	},
	{
		number: 3,
		icon: Play,
		title: 'Animate and share',
		description: 'Watch plays come to life with real-time animation. Export to PowerPoint or PDF for your staff.',
	},
]

export function HowItWorks() {
	return (
		<section id="how-it-works" className="landing-how-it-works-section">
			<div className="landing-how-it-works-container">
				<h2 className="landing-section-title">How it works</h2>
				<p className="landing-section-subtitle">
					From blank canvas to animated play in under a minute
				</p>

				<div className="landing-how-it-works-grid">
					{STEPS.map((step, index) => (
						<div
							key={step.number}
							className="landing-how-it-works-column"
							style={{ animationDelay: `${index * 150}ms` }}
						>
							<div className="landing-how-it-works-number">{step.number}</div>
							<div className="landing-how-it-works-step">
								<div className="landing-how-it-works-icon">
									<step.icon />
								</div>
								<h3 className="landing-how-it-works-step-title">{step.title}</h3>
								<p className="landing-how-it-works-step-description">{step.description}</p>
							</div>
						</div>
					))}
				</div>
			</div>
		</section>
	)
}
